import Service from "@/untils/request";
import qs from "qs";
/**
 * 获取轮播图
 */
export function getSwipper() {
  return Service({
    url: "rotationChart/getList",
    method: "post"
  });
}
/**
 * 获取筛选分类
 */
export function getSort(data) {
  return Service({
    url: "user/getScreenList",
    method: "post",
    data: data
  });
}
/**
 * 获取筛选分类
 */
export function getCraftsmanListPage(data) {
  return Service({
    url: "user/getCraftsmanListPage",
    method: "post",
    data: data
  });
}
/**
 * 获取省
 */
export function getProvince() {
  return Service({
    url: "consignee/getProvince",
    method: "get"
  });
}
/**
 * 获取工长列表
 */
export function getCraftsmanList(data) {
  return Service({
    url: "user/getCraftsmanList",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 根据名字搜索接口
 */
export function getDataByName(data) {
  return Service({
    url: "user/getDataByName",
    method: "post",
    data: data
  });
}
/**
 * 获取工厂接口详情
 */
export function getUserSingleData(data) {
  return Service({
    url: "user/getUserSingleData",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 获取业绩列表
 */
export function getCraftsmanAchievementList(data) {
  return Service({
    url: "craftsmanAchievement/getCraftsmanAchievementList",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 获取业绩详情接口
 */
export function getCraftsmanAchievementListDetail(data) {
  return Service({
    url: "craftsmanAchievement/getDetailByAchievementId",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 获取个人相册
 */
export function getCraftsmanPhotoList(data) {
  return Service({
    url: "/personalCenter/getCraftsmanPhotoList",
    method: "post",
    data: qs.stringify(data)
  });
}
/*
 * 认证接口
 */
export function authentication(data) {
  return Service({
    url: "user/authentication",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 获取工匠集群分类人数接口
 */
export function getCraftsmanListPeople() {
  return Service({
    url: "user/getCraftsmanListPeople",
    method: "post"
  });
}
/**
 * 入库
 */
export function addWorkersBank(data) {
  return Service({
    url: "personalCenter/addWorkersBank",
    method: "post",
    data: data
  });
}
/**
 * 获取具体分类中的列表数据
 * 顺序==》1:瓦工2:木工3:油漆工4:水暖工5:电工6:幕墙工7:焊工8:防水工9:拆旧工10:模板工11:架子工12:钢筋工13:钣金工14:杂工15:其它工种
 */
export function getCraftsmanTypeDataList(data) {
  return Service({
    url: "user/getCraftsmanTypeDataList",
    method: "post",
    data: data
  });
}
/**
 * 资讯获取列表
 */
export function getCraftsmanInformationList(data) {
  return Service({
    url: "craftsmanInformation/getCraftsmanInformationList",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 资讯获取列表详情id
 */
export function getCraftsmanInformationDetail(data) {
  return Service({
    url: "craftsmanInformation/getCraftsmanInformationDetail",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 匠心作品获取列表
 */
export function getCraftsmanLists(data) {
  return Service({
    url: "platformWorks/getCraftsmanList",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 匠心作品获取详情
 */
export function getIngenuityWorksDetails(data) {
  return Service({
    url: "platformWorks/getIngenuityWorksDetails",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 验证码
 */
export function getSendIdentifyingCode(data) {
  return Service({
    url: "/user/sendIdentifyingCode",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 登录
 */
export function getLoginByMobile(data) {
  return Service({
    url: "/user/loginByMobile",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 登录
 */
export function getRegister(data) {
  return Service({
    url: "/user/register",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 点击个人中心按钮接口
 */
export function getAuthentication(data) {
  return Service({
    url: "/personalCenter/authentication",
    method: "post",
    data: qs.stringify(data)
  });
}
/*
 * 上传图片
 */
export function upload(data) {
  return Service({
    url: "/common/upload",
    method: "post",
    data: data
  });
}
/**
 * 点击个人中心按钮接口
 */
export function insertInformation(data) {
  return Service({
    url: "/personalCenter/insertInformation",
    method: "post",
    data: data
  });
}
/**
 * 获取工长信息
 */
export function getCraftsman(data) {
  return Service({
    url: "personalCenter/getCraftsman",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 修改工长信息
 */
export function editUpAContingent(data) {
  return Service({
    url: "personalCenter/editUpAContingent",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 获取队伍组建页数据接口
 */
export function getCraftsmanTeamData(data) {
  return Service({
    url: "personalCenter/getCraftsmanTeamData",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 上传队伍信息接口
 */
export function setupAContingentSingle(data) {
  return Service({
    url: "personalCenter/setupAContingentSingle",
    method: "post",
    data: data
  });
}
/**
 * 修改队伍工人接口
 */
export function updateCraftsmanPeopleInformation(data) {
  return Service({
    url: "personalCenter/updateCraftsmanPeopleInformation",
    method: "post",
    data: data
  });
}
/**
 * 删除工人上传信息
 */
export function removeCraftsmanTeamInformation(data) {
  return Service({
    url: "personalCenter/removeCraftsmanTeamInformation",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 修改队伍规模接口&&上传队伍信息接口
 */
export function updateCraftsmanTeamSize(data) {
  return Service({
    url: "personalCenter/updateCraftsmanTeamSize",
    method: "post",
    data: data
  });
}
/**
 * 删除照片
 */
export function removeCraftsmanTeamInformationPhoto(data) {
  return Service({
    url: "personalCenter/removeCraftsmanTeamInformationPhoto",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 获取用工信息
 */
export function getEmploymentInformationList(data) {
  return Service({
    url: "employmentInformation/getEmploymentInformationList",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 获取用工信息详情
 */
export function getEmploymentInformationDetail(data) {
  return Service({
    url: "employmentInformation/getEmploymentInformationDetail",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 判断是否登录
 */
export function judgeUserIsLogin(data) {
  return Service({
    url: "serviceConsultation/judgeUserIsLogin",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 添加服务信息
 */
export function addServiceConsult(data) {
  return Service({
    url: "/serviceConsultation/addServiceConsultation",
    method: "post",
    data: data
  });
}
/**
 * 选择项目列表接口
 */
export function getListByCraftsmanId(data) {
  return Service({
    url: "craftsmanAchievement/getListByCraftsmanId",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 业绩管理
 */
export function getCraftsmanAchievementByType(data) {
  return Service({
    url: "/craftsmanAchievement/getCraftsmanAchievementByType",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 添加业绩上传
 */
export function addCraftsmanAchievement(data) {
  return Service({
    url: "/craftsmanAchievement/addCraftsmanAchievement",
    method: "post",
    data: data
  });
}
/**
 * 添加业绩上传
 */
export function getCity(data) {
  return Service({
    url: "/consignee/getCity/?provinceId=" + data.provinceId,
    method: "get",
    data: qs.stringify(data)
  });
}
/**
 * 添加业绩修改
 */
export function editCraftsmanAchievement(data) {
  return Service({
    url: "/craftsmanAchievement/editCraftsmanAchievement",
    method: "post",
    data: data
  });
}
/**
 * 添加业绩修改
 */
export function getCraftsmanAchievementDetails(data) {
  return Service({
    url: "/craftsmanAchievement/getCraftsmanAchievementDetails",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 删除工人上传信息
 */
export function removeCraftsmanAchievement(data) {
  return Service({
    url: "/craftsmanAchievement/removeCraftsmanAchievement  ",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 是否登录接口
 */
export function judge(data) {
  return Service({
    url: "isLogin/judge",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 分享到朋友圈
 */
export function jsApiTicket(data) {
  return Service({
    url: "/wxToken/jsApiTicket",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 静态图片
 */
export function getData(data) {
  return Service({
    url: "staticPage/getData",
    method: "post",
    data: qs.stringify(data)
  });
}
/**
 * 静态图片
 */
export function beforeAddCraftsmanAchievement(data) {
  return Service({
    url: "/craftsmanAchievement/beforeAddCraftsmanAchievement",
    method: "post",
    data: qs.stringify(data)
  });
}



// WEBPACK FOOTER //
// ./src/api/index.js